/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable no-prototype-builtins */
/* eslint-disable prefer-const */
import { Injectable } from "@angular/core";
import { Configuration } from "@content-platform/web-angular-shared-util-configuration";
import { LoggerService } from "@content-platform/web-angular-shared-util-logging";
import { Client } from "@microsoft/microsoft-graph-client";
import { UserAgentApplication } from "msal";
import { AUTH_AUTHORITY } from "./auth-api.config";
import { BehaviorSubject, filter, switchMap, take } from 'rxjs';
import { Router } from "@angular/router";
import { SCOPE } from "./msal.service.config";
import { Store } from "@ngrx/store";
import { getADUser, getGraphToken } from "./auth/auth.selectors";
import * as i0 from "@angular/core";
import * as i1 from "@content-platform/web-angular-shared-util-logging";
import * as i2 from "@angular/router";
import * as i3 from "@ngrx/store";
const tokens = {};
const tokens$ = new BehaviorSubject(tokens);
export class MSALService {
    constructor(loggerService, router, store) {
        this.loggerService = loggerService;
        this.router = router;
        this.store = store;
        this.constructMsalService();
        this.logger = this.loggerService.instance("MsGraphApiService");
    }
    constructMsalService() {
        Configuration.getAsync("adal")
            .pipe(filter((config) => !!config), take(1))
            .subscribe((adalConfig) => {
            const config = this.getAuthConfig(adalConfig.clientId);
            this.authContext = new UserAgentApplication(config);
            this.handleCallback();
            this.graphClient = this.initializeGraphClient();
        });
    }
    /**
     * Returns the authentication config needed to create the auth context
     * @param clientId
     */
    getAuthConfig(clientId) {
        const redirectUri = window.location.href || window.location.origin;
        return {
            auth: {
                clientId: clientId,
                authority: AUTH_AUTHORITY,
                validateAuthority: true,
                redirectUri: redirectUri
            }
        };
    }
    /**
     * Initialize the Graph client with an auth provider that requests the token from the auth service
     */
    initializeGraphClient() {
        return (this.graphClient = Client.init({
            authProvider: async (done) => {
                this.store
                    .select(getADUser)
                    .pipe(filter((user) => !!user), switchMap(() => this.store.select(getGraphToken)))
                    .subscribe((token) => done(null, token));
            },
            defaultVersion: "beta"
        }));
    }
    /**
     * Gets user's account
     * @deprecated given_name and family_name properties will be removed
     */
    getUserAccount() {
        let given_name;
        let family_name;
        const msalAccount = this.authContext.getAccount();
        given_name =
            msalAccount && msalAccount.idToken && msalAccount.idToken.hasOwnProperty("given_name")
                ? msalAccount.idToken["given_name"]
                : "undefFirsttName";
        family_name =
            msalAccount && msalAccount.idToken && msalAccount.idToken.hasOwnProperty("family_name")
                ? msalAccount.idToken["family_name"]
                : "undefLastName";
        return msalAccount
            ? {
                userName: msalAccount.userName,
                profile: {
                    ...msalAccount.idToken,
                    unique_name: msalAccount.userName,
                    upn: msalAccount.userName,
                    family_name: family_name,
                    given_name: given_name
                }
            }
            : null;
    }
    /**
     * Gets initial Idtoken for the app backend
     * Saves the resulting Idtoken in localStorage.
     */
    login() {
        const loginRequest = {
            scopes: [SCOPE]
        };
        this.authContext.loginRedirect(loginRequest);
    }
    /**
     * Logout user will redirect page to logout endpoint.
     * After logout, it will redirect to post_logout page if provided.
     */
    logout() {
        this.authContext.logout();
    }
    /**
     * Gets an observable  of a token token for the specified resource
     * @param resource {string} the resource to get token for
     * @returns {Observable<{ [resource: string]: string }>} token
     */
    get accessTokens$() {
        return tokens$;
    }
    /**
     * Get state for authenticated user
     */
    getisAuthenticated() {
        return !!this.authContext.getAccount();
    }
    handleCallback() {
        this.authContext.handleRedirectCallback(this.authCallback);
    }
    authCallback(error, response) {
        if (error) {
            this.logger.error(JSON.stringify(error));
        }
        if (response) {
            this.logger.info(JSON.stringify(response));
        }
    }
    static { this.ɵfac = function MSALService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MSALService)(i0.ɵɵinject(i1.LoggerService), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.Store)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MSALService, factory: MSALService.ɵfac, providedIn: "root" }); }
}
//# sourceMappingURL=msal.service.js.map